export const hdxLinks = {
    AFG: {
        link:
            'https://data.humdata.org/dataset/236c8d9b-49e2-4cb8-ac37-e5831d0958e2/resource/bac4efbb-6a67-4e09-87dc-a6eaf9d1be97/download',
    },
    BDI: {
        link:
            'https://data.humdata.org/dataset/9ed347bd-bcf3-4039-85ac-68b0be66b2e2/resource/8c49a503-c5fa-4e6c-8e03-87a5dd6279e3/download',
    },
    BFA: {
        link:
            'https://data.humdata.org/dataset/34219a16-6fa6-4592-bd71-017cead722bb/resource/77663d46-3901-48f1-98ad-68defaf221da/download',
    },
    CAF: {
        link:
            'https://data.humdata.org/dataset/15131e8b-0ec0-43e9-9639-fe80d34715cf/resource/5c3b6f3f-d85e-41b1-82ef-db88b62d7e6f/download',
    },
    CMR: {
        link:
            'https://data.humdata.org/dataset/e8257d8d-2325-45dc-a0d0-2186947aab01/resource/b9d43c26-1a89-4cc4-ad75-53023246359e/download',
    },
    COL: {
        link:
            'https://data.humdata.org/dataset/3495cbbc-7b8f-4d8e-a53b-a2a9ffa3aa0e/resource/ea8a2b45-c2c1-407b-bde2-a68854678cee/download',
    },
    COD: {
        link:
            'https://data.humdata.org/dataset/e532bc38-6828-4b56-9f0b-bfce73b14a74/resource/002f74f7-beaa-4d13-a5fb-991e74f09626/download',
    },
    ETH: {
        link:
            'https://data.humdata.org/dataset/2e68a277-a9b2-43da-b5fb-5addee461751/resource/f397871e-9388-417e-8b31-02f93384408d/download',
    },
    HTI: {
        link:
            'https://data.humdata.org/dataset/91912c56-617c-4164-9790-d05d43032e8e/resource/6e5fda2b-fbd1-4c60-9e5e-b52eb1c5939d/download',
    },
    IND: {
        link:
            'https://data.humdata.org/dataset/baff2df3-e7e1-46a7-a3aa-2d26cc160e42/resource/7c821ea4-1532-4251-ae27-08107639bc58/download',
    },
    IRQ: {
        link:
            'https://data.humdata.org/dataset/868477b4-834a-43d8-a7ef-64c59d650a29/resource/5c006785-137d-4e57-ac08-e8eae4e24a49/download',
    },
    IRN: {
        link:
            'https://data.humdata.org/dataset/27f98773-f05d-47e9-9fba-764aab22066b/resource/8eb8a3ec-1482-46c8-aef9-d86839d1b26a/download',
    },
    ISR: {
        link:
            'https://data.humdata.org/dataset/6a912c4e-7196-4ad8-bda8-4af89132c968/resource/bd5d0dd4-56f2-4c38-ac11-186929b8ccc9/download',
    },
    LBN: {
        link:
            'https://data.humdata.org/dataset/52503c9f-f575-43c0-87d2-83b9d3197d0a/resource/8cd0ce1f-2b87-4bc3-aadc-9637c557b6b5/download',
    },
    LBY: {
        link:
            'https://data.humdata.org/dataset/800e1c11-9843-4b6e-8723-023e20ed67a6/resource/0d8581d9-89e8-4aff-9c87-61ea8a85ca16/download',
    },
    MLI: {
        link:
            'https://data.humdata.org/dataset/b1b2912c-b004-47de-83e3-80d022638a02/resource/c62306bd-97ab-48f9-802d-d923fbc7b13e/download',
    },
    MEX: {
        link:
            'https://data.humdata.org/dataset/7c4c7009-961c-4cbf-bebe-2da38582efab/resource/1d6ea982-2689-4200-8b69-f6c581bfefde/download',
    },
    MOZ: {
        link:
            'https://data.humdata.org/dataset/cfb7ac47-a30d-4b71-8b8e-bf331a9a4b11/resource/d20b2ab0-5f1e-4efc-a2da-521c145816db/download',
    },
    MMR: {
        link:
            'https://data.humdata.org/dataset/63605720-f0da-454d-89a6-552f1acc3a53/resource/10bb58b7-b29c-495a-bb6d-a0be727f46dc/download',
    },
    NER: {
        link:
            'https://data.humdata.org/dataset/50a644b7-49d4-4841-af87-7aa42a12acd0/resource/7aeaf7fe-6bed-4f2a-8fd7-a19b01cb3fd3/download',
    },
    NGA: {
        link:
            'https://data.humdata.org/dataset/ee89c911-33e4-42e9-b3e2-f538cd3e21d5/resource/abb922da-af4f-42aa-97b0-84214739891e/download',
    },
    PAK: {
        link:
            'https://data.humdata.org/dataset/066f2c9e-9b03-4af5-9f52-49018a9a589c/resource/a6671e23-c637-42f4-9916-15aec1bfb452/download',
    },
    SOM: {
        link:
            'https://data.humdata.org/dataset/b06b223b-499f-4d6f-b6a8-5501497f9613/resource/9471db03-751c-436d-8ac2-c171f779cc0a/download',
    },
    SSD: {
        link:
            'https://data.humdata.org/dataset/e1861491-f2c3-4eb2-b7a1-0391520b5b50/resource/51766fff-423f-45d1-a16e-67d345477d6b/download',
    },
    PSE: {
        link:
            'https://data.humdata.org/dataset/b36e1975-4428-4caa-9b00-e0d8793130d0/resource/e5e62e1c-7350-416a-8077-10c948652d84/download',
    },
    SDN: {
        link:
            'https://data.humdata.org/dataset/681c1690-6c99-4c66-842c-0ab99a731af4/resource/cd122a85-70ed-471a-a631-193f92c72b26/download',
    },
    SYR: {
        link:
            'https://data.humdata.org/dataset/0aed076c-5e32-4dfd-a5f2-2779d153dc90/resource/16febfd2-0c56-49fd-b98d-6d08ecffb7f7/download',
    },
    UKR: {
        link:
            'https://data.humdata.org/dataset/f21002e5-4e00-4c95-bff1-ecd698bf9ff4/resource/03db9083-4f16-4337-b20b-26aae4fe59dc/download',
    },
    YEM: {
        link:
            'https://data.humdata.org/dataset/c54fcc03-5c96-4911-bea0-d21a7fa56524/resource/15925ae9-98f6-449f-b7a6-a161a5714f56/download',
    },
};
